import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import { DefinedPermissions } from '../Constants/Permissions'
import { Auth } from 'aws-amplify'
import SearchandStatus from './SearchandStatus'
import CollectionDisplayTable from './CollectionDisplayTable'
import UpdateCollectionStatusService from '../../Services/Mutations/UpdateCollectionStatusService'
import { ToastStyle } from '../Data/MovieStaticData'
import GetUserPermissions from '../../Services/Queries/GetUserPermissions'
import ListMovieCollectionsService from '../../Services/Queries/ListMovieCollectionsService'
import SearchListsAndCollectionsService from '../../Services/Queries/SearchListsAndCollections'

export default function ListMovieCollections() {
  const [listMovieCollections, setListMovieCollections] = useState([])
  const [loadSpinner, setLoadSpinner] = useState(false)
  const [nextToken, setNextToken] = useState('')
  const [searchText, setSearchText] = useState('')
  const [from, setFrom] = useState('')
  const [status, setStatus] = useState('published')
  const [ApproveOptionBoolean, setApproveOptionBoolean] = useState(false)
  const [checkedArray, setCheckedArray] = useState([])
  const [EDitOptionPermission, setEDitOptionPermission] = useState(false)
  const [DeleteOptionPermission, setDeleteOptionPermission] = useState(false)
  const [BulkActionPermission, setBulkActionPermission] = useState(false)

  const fetchCollectionData = async (input, append = false) => {
    setLoadSpinner(true)
    const response = await ListMovieCollectionsService(input)
    setListMovieCollections(prev =>
      append ? [...prev, ...response.items] : response.items,
    )
    setNextToken(response.nextToken)
    setLoadSpinner(false)
  }

  const loadMore = async () => {
    setFrom('')
    await fetchCollectionData({ limit: 10, nextToken, status }, true)
  }

  const selectStatus = event => {
    setLoadSpinner(true)
    setStatus(event.target.value)
    setSearchText('')
    setNextToken(null)
    setLoadSpinner(false)
  }

  const handleSearch = async () => {
    setLoadSpinner(true)
    const input = {
      type: 'collections',
      search: searchText,
      sortBy: 'views',
      sortOrder: 'asc',
      from: 0,
      limit: 10,
    }
    const response = await SearchListsAndCollectionsService(input)
    setListMovieCollections(response.items)
    setFrom(10)
    setLoadSpinner(false)
  }

  const clearText = () => {
    setSearchText('')
    setFrom('')
    setStatus('published')
    fetchCollectionData({ status: 'published', limit: 10 })
    setNextToken(null)
  }

  const loadMoreSearch = async () => {
    setNextToken(null)
    const input = {
      type: 'collections',
      search: searchText,
      sortBy: 'views',
      sortOrder: 'asc',
      from,
      limit: 10,
    }
    await fetchCollectionData(input, true)
    setFrom(prevFrom => prevFrom + 10)
  }

  const handleCollectionStatusUpdate = async (item, index, newStatus) => {
    setLoadSpinner(true)
    try {
      const listMovieCollectionsTemp = [...listMovieCollections]
      listMovieCollectionsTemp.splice(index, 1)
      await UpdateCollectionStatusService({
        movieCollectionID: item.movieCollectionID,
        status: newStatus,
      })
      setListMovieCollections(listMovieCollectionsTemp)
      setLoadSpinner(false)
      toast.success(`Collection ${newStatus} successfully.`, ToastStyle)
    } catch (error) {
      console.error('Error updating collection status:', error)
      setLoadSpinner(false)
      toast.error('Error updating collection status. Please try again.', ToastStyle)
    }
  }

  const getPermissions = async () => {
    const permissionInput = { mobileNumber: Auth.user.attributes.phone_number }
    const userPermissions = await GetUserPermissions(permissionInput)
    const permissionsArray =
  userPermissions?.userRolesAndPermissions?.reduce(
    (flattenedPermissions, role) => [...flattenedPermissions, ...role.permissions.map(permission => permission.name)],
    [],
  ) || []

    setApproveOptionBoolean(
      permissionsArray.includes(DefinedPermissions.CollectionApprove,
      ))

    setEDitOptionPermission(
      permissionsArray.includes(
      DefinedPermissions.CollectionEdit,
    ))
    setDeleteOptionPermission(permissionsArray.includes(
      DefinedPermissions.CollectionDelete,
    ))
    setBulkActionPermission(permissionsArray.includes(
      DefinedPermissions.CollectionBulkActions,
    ))
  }

  useEffect(() => {
    fetchCollectionData({ status, limit: 10 })
  }, [status])

  useEffect(() => {
    getPermissions()
  }, [])

  return (
    <>
      <label> All movies collection</label>
      <SearchandStatus
        searchText={searchText}
        SearchText={setSearchText}
        searchButton={handleSearch}
        selectStatus={selectStatus}
        status={status}
        Cleartext={clearText}
        checkedArray={checkedArray}
        setLoadSpinner={setLoadSpinner}
        setCheckedArray={setCheckedArray}
        listMovieCollections={listMovieCollections}
        setlistMovieCollections={setListMovieCollections}
        BulkActionPermission={BulkActionPermission}
      />
      <br />
      <CollectionDisplayTable
        checkedArray={checkedArray}
        setCheckedArray={setCheckedArray}
        loadSpinner={loadSpinner}
        listMovieCollections={listMovieCollections}
        status={status}
        ApproveOptionBoolean={ApproveOptionBoolean}
        EDitOptionPermission={EDitOptionPermission}
        DeleteOptionPermission={DeleteOptionPermission}
        BulkActionPermission={BulkActionPermission}
        ApproveCollection={(item, index) =>
          handleCollectionStatusUpdate(item, index, 'published')
        }
        deleteFunction={(item, index) =>
          handleCollectionStatusUpdate(item, index, 'deleted')
        }
        nextToken={nextToken}
        loadMore={loadMore}
        from={from}
        loadMoreSearch={loadMoreSearch}
      />
    </>
  )
}
